module.exports = __webpack_public_path__ + "static/portfolio-4-a1a8c41a90eaf5d8c2697f8f7bf6af9d.jpg";